<template>
  <b-form class="account-form"
          @submit="onSubmit">
    <label class="account-form__label"
           for="email">Email Address</label>
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text>
          <font-awesome-icon :icon="['fal', 'envelope']"
                             aria-hidden="true"></font-awesome-icon>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        id="email"
        v-model="email"
        type="email"
        placeholder="Email Address"
        required></b-form-input>
    </b-input-group>
    <label class="account-form__label"
           for="email">User Type</label>
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text>
          <font-awesome-icon :icon="['fal', 'users']"
                             aria-hidden="true"></font-awesome-icon>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-select v-model="selectedUserType"
                required>
        <b-select-option value="null"
                         selected>
          Please select
        </b-select-option>
        <b-select-option
          v-for="(userType, index) in userTypes"
          :key="index"
          :value="userType.webUserTypeParentId">
          {{ userType.webUserTypeParent }}
        </b-select-option>
      </b-select>
    </b-input-group>
    <div class="submit-button__container">
      <b-button type="submit"
                class="submit-button"
                variant="accent-1">
        Create Account
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { webAccountUserTypes } from "~/Scripts/services/registrationService";

export default {
  name: "RegisterForm",
  data () {
    return {
      email: null,
      selectedUserType: null,
      userTypes: [],
    };
  },
  mounted () {
    webAccountUserTypes()
      .then( response => {
        this.userTypes = response.data || [];
      } )
      .catch( () => {
        this.userTypes = [];
      } );
  },
  methods: {
    onSubmit () {
      console.log( "register submit" );
    },
  },
};
</script>
